exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg[data-v-23e98469] {\n    background-color: #ffffff;\n}\n.rule p[data-v-23e98469] {\n    display: inline-block;\n}\n.result_num[data-v-23e98469]{\n    height: 45px;\n    line-height: 45px;\n    padding: 0px 15px;\n}\n.result[data-v-23e98469] {\n    padding: 20px 15px;\n}\n.inte[data-v-23e98469] {\n    color: #1a96d4;\n}\n.step img[data-v-23e98469] {\n    width: 150px;\n}\n.info[data-v-23e98469] {\n    background-color: #ffffff;\n    padding: 20px 15px;\n    border-radius: 10px;\n}\nspan[data-v-23e98469] {\n    color: #f03e3e;\n}\n.go[data-v-23e98469] {\n    color: #adadad;\n    font-size: 10px;\n}\n", ""]);

// exports
